import { Seo } from "../components/Seo";
import { Reveal, Eyebrow } from "../components/Reveal";
import ServicesGrid from "../components/sections/ServicesGrid";
import Emergency from "../components/sections/Emergency";
import CtaBand from "../components/sections/CtaBand";
import { Marquee } from "../components/Marquee";
import { SERVICES } from "../lib/data";

const Services = () => (
  <main data-testid="services-page">
    <Seo
      title="Gas Station Maintenance & Contracting Services | Petroline Services Ontario"
      description="General contracting, station renovations, forecourt repairs, electrical, mechanical, car-wash maintenance, equipment maintenance and emergency service for petroleum retail facilities in Ontario."
    />

    <section className="mx-auto max-w-7xl px-5 pb-16 pt-24 lg:px-8 lg:pt-32">
      <Reveal>
        <Eyebrow>Services</Eyebrow>
        <h1 className="max-w-3xl font-display text-4xl font-extrabold leading-tight tracking-tight sm:text-5xl lg:text-6xl">
          Contracting, Repair &amp; Maintenance for <span className="text-ember">Petroleum Retail</span>
        </h1>
        <p className="mt-6 max-w-2xl text-base leading-relaxed text-mist md:text-lg">
          Eight core service lines covering the full property — from the forecourt to the
          building systems — delivered by one coordinated commercial contractor.
        </p>
      </Reveal>
    </section>

    <Marquee items={SERVICES.map((s) => s.title)} testId="services-page-marquee" />
    <ServicesGrid showCta={false} />
    <Emergency />
    <CtaBand title="Have a maintenance issue or upcoming project?" subtitle="Talk to Petroline Services about your facility's requirements — repairs, renovations or ongoing maintenance." />
  </main>
);

export default Services;
